import { createV3Queries } from "@query/utils/createV3Queries";
import { documentTemplatesApi } from "@api";
import {
  QUERY_EXTENDED_REQUIREMENT_DEFINITION,
  QUERY_EXTENDED_REQUIREMENT_DEFINITIONS
} from "../../query/requirementDefinitions/keys";

/**
 * Document-template registry — mirrors `DocumentTemplatesApi` 1:1
 * (`/v3/compliance/document-templates`). Templates are the data-source
 * settings behind `Signature` requirement definitions, so template writes
 * refresh the "extended" definition reads that join a definition with its
 * template.
 */
export const queriesDocumentTemplates = createV3Queries(
  "documentTemplatesApi",
  documentTemplatesApi,
  {
    createDocumentTemplate: () => ({
      dependencies: () => [QUERY_EXTENDED_REQUIREMENT_DEFINITIONS]
    }),
    updateDocumentTemplate: () => ({
      dependencies: () => [
        QUERY_EXTENDED_REQUIREMENT_DEFINITION,
        QUERY_EXTENDED_REQUIREMENT_DEFINITIONS
      ]
    }),
    deleteDocumentTemplate: () => ({
      dependencies: () => [
        QUERY_EXTENDED_REQUIREMENT_DEFINITION,
        QUERY_EXTENDED_REQUIREMENT_DEFINITIONS
      ]
    })
  }
);
